import {Component, inject, input, output} from '@angular/core';
import {MapLayer} from '../../../../../../shared/classes/map-layer';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {GenServiceType} from '../../../../../../generated/serverModels/GenServiceType';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {LayerService} from '../../../../../../services/layer.service';
import {MapGroup} from '../../../../../../shared/classes/map-group';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SNACKBAR_DURATION } from '../../../../../../shared/constants/snackbar.constants';

@Component({
    selector: 'tgrid-modify-map-layer',
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        MatButton,
        CdkTextareaAutosize,
        MatSelect,
        MatOption,
        MatSlideToggle,
    ],
    templateUrl: './modify-map-layer.component.html',
    standalone: true,
    styleUrl: './modify-map-layer.component.scss',
})
export class ModifyMapLayerComponent {
  public layer = input<MapLayer | undefined>();
  public groups = input<MapGroup[]>([]);
  public layerUpdated = output<MapLayer>();
  public cancelUpdate = output<void>();

  protected serviceTypes = GenServiceType;
  private layerService = inject(LayerService);
  private snackBar = inject(MatSnackBar);



  protected formGroup: FormGroup = new FormGroup({
    displayName: new FormControl<string>('', {validators: [Validators.required]}),
    description: new FormControl<string>(''),
    serviceType: new FormControl<string>('', {validators: [Validators.required]}),
    serviceLayer: new FormControl<string>('', {validators: [Validators.required]}),
    serviceUrl: new FormControl<string>('', {validators: [Validators.required]}),
    attributionTitle: new FormControl<string>('', {validators: [Validators.required]}),
    attributionUrl: new FormControl<string>('', {validators: [Validators.required]}),
    layerGroup:new FormControl<number>(-1, {validators: [Validators.required]}),
    enabled: new FormControl<boolean>(true),
  });

  constructor() {
    toObservable(this.layer).pipe(
      filter(layer => !!layer),
      takeUntilDestroyed(),
    )
      .subscribe((layer: MapLayer) => {
        this.formGroup.patchValue({
          displayName: layer.displayName,
          description: layer.description,
          serviceType: layer.serviceType,
          serviceLayer: layer.serviceLayer,
          serviceUrl: layer.serviceUrl,
          attributionTitle: layer.attributionTitle,
          attributionUrl: layer.attributionUrl,
          layerGroup: layer.layerGroupId,
          enabled: layer.active,
        });
      });
  }

  public updateLayer() {

    const formValue = this.formGroup.getRawValue();
    const newLayer = new MapLayer({
      ...this.layer(),
      ...formValue,
      layerGroupId: formValue.layerGroup,
      active: formValue.enabled,
    });
    this.layerService.updateLayer(newLayer).subscribe({
      next: (layer) => {
        this.snackBar.open('Updated Layer', 'X', { duration: SNACKBAR_DURATION.MEDIUM });
        this.layerUpdated.emit(layer);
      },
      error: (error) => {
        this.snackBar.open('Unable to update layer', 'X', { duration: SNACKBAR_DURATION.MEDIUM });
        console.error(error);
      },
    });
  }

  public cancelLayerUpdate() {
    this.cancelUpdate.emit();
  }
}
